import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateDeviceStatusParams } from "core/http/service/notification/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const updateDeviceStatus = createSlice({
  name: "updateDeviceStatus",
  initialState,
  reducers: {
    updateDeviceStatusStart: (
      state,
      action: PayloadAction<UpdateDeviceStatusParams>
    ) => {
      state.status = ReduxStateType.INIT;
    },
    updateDeviceStatusSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    updateDeviceStatusFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  updateDeviceStatusStart,
  updateDeviceStatusSuccess,
  updateDeviceStatusFailed,
} = updateDeviceStatus.actions;

export default updateDeviceStatus.reducer;
